// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"169":"5634013d","320":"9edc3fda"}[chunkId] + ".chunk.js";
};